/**
 * Route for `campaign-language-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignLanguageTargetingPage } from "../features/campaign-language-targeting/CampaignLanguageTargetingPage";

export const campaignLanguageTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-language-targeting",
	component: CampaignLanguageTargetingPage,
});

export default campaignLanguageTargetingRoute;
